import { useEffect } from 'react'
import { Layout, Row, Button, Image, Typography } from 'antd'
import { MailOutlined, PhoneOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { LanguageSwitch } from '../components/'
import { useAuth } from '../context/AuthProvider'

const Header = () => {
  const { user, token } = useAuth()

  return (
    <Layout.Header>
      <a href="https://grin.com" target="_blank" rel="noreferrer">
        <img
          className="logo"
          src="https://www.grin.com/wp-content/uploads/2020/08/grin_logo_claim_212.svg"
          // src={t('grin.logo')}
          alt="Grin logo"
        />
      </a>
      {token && (
        <a className="user-name" href="/login/#account" target="_blank">
          <Typography.Paragraph>
            {user && <Typography.Text role="user">{user}</Typography.Text>}
            <Image
              src="images/login/person-fill.svg"
              preview={false}
              alt="person icon"
            />
          </Typography.Paragraph>
        </a>
      )}
      <LanguageSwitch />
    </Layout.Header>
  )
}

const Footer = () => {
  const { t } = useTranslation()
  return (
    <Layout.Footer>
      <Row className="call-us">
        <p>
          <img
            style={{ marginRight: '22px', verticalAlign: '-13px' }}
            src="https://www.grin.com/wp-content/uploads/2020/08/ico_grin_white.svg"
            alt="Grin smile"
            width="40"
          />
          {t('Footer.DoYouHave')}
          <a href="mailto:info@grin.com">
            <MailOutlined />
            info@grin.com
          </a>
          <a href="tel:+49 89 550559-0">
            <PhoneOutlined />
            +49 89 550559-0
          </a>
        </p>
      </Row>
      <Row className="links">
        <ul>
          <li>
            <a href={t('Footer.Privacy.link')}>{t('Footer.Privacy')}</a>
          </li>
          <li>
            <a href={t('Footer.Terms.link')}>{t('Footer.Terms')}</a>
          </li>
          <li>
            <a href={t('Footer.Imprint.link')}>{t('Footer.Imprint')}</a>
          </li>
        </ul>
      </Row>
    </Layout.Footer>
  )
}

const Page = ({ children, title, className = '' }) => {
  useEffect(() => {
    document.title = ['Grin', title].join(' | ')
  }, [title])

  return (
    <Layout>
      <Header />
      <Layout.Content className={className}>{children}</Layout.Content>
      <Footer />
    </Layout>
  )
}

export default Page
